<template>
  <el-dialog
    title="添加成员"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    width="40%"
  >
    <div
          class="dialog_transfer_box"
        >
          <el-transfer
            v-model="addDataList"
            :props="{
              key: 'userId',
              label: 'userName',
              disabled: 'disabledSelect'
            }"
            :titles="['待选择成员列表', '待提交成员列表']"
            :data="userDataList"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="请输入成员名称"
          >
            <el-button
              class="transfer-footer"
              type="primary"
              style="float:right;margin:5px"
              slot="right-footer"
              size="small"
              :disabled='addDataList.length > 0 ? false : true'
              @click="addDataAction()"
              >提交</el-button
            >
          </el-transfer>
        </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    roleId: {
      type: String
    }
  },
  data() {
    //这里存放数据
    return {
      addDataList: [],
      userDataList:[],
      filterMethod(query, item) {
        return item.userName.indexOf(query) > -1;
      },
      requestData: {
        eduId: this.$store.getters.getEduData.eduId,
        pageNum: 1,
        pageSize: 10000,
        userPhone: "",
        userName: "",
        departmentId: ""
      },
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      if (val) {
        this.getUserDataList()
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
      // 获取数据列表
    async getUserDataList() {
      let res = await this.$Http.getEduUserList(this.requestData);
      if (res.code == 200) {
        let list = res.data.list || [];
        this.userDataList = list.map((item,index)=>{
          item.disabledSelect = item.roleName == '' ? false : true
          return item
        })
      } else if (res.code == 101) {
        this.userDataList = []
      } else {
        this.userDataList = []
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async addDataAction() {
      let req = this.addDataList.map((item) => {
        return { userId: item, roleId: this.roleId };
      });
      let res = await this.$Http.addRoleMember(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.close()
        this.addDataList = [];
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    close(){
        this.$emit('close')
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
@import "../../../../../public/css/edu_pages.scss";
</style>
